import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./module-search-controls.scss";

const ModuleSearchControls = ({
  value,
  onChange,
  placeholder = "Search",
  children,
  className = "",
}) => {
  return (
    <div className={`module-search-controls ${className}`.trim()}>
      <label className="module-search-controls__search">
        <span>
          <Icon icon="ph:magnifying-glass" height={16} />
        </span>
        <input value={value} onChange={(event) => onChange(event.target.value)} placeholder={placeholder} />
      </label>
      <div className="module-search-controls__actions">{children}</div>
    </div>
  );
};

export default ModuleSearchControls;
